import styled, { css } from 'styled-components';
import StopStatusLogStage from './container';

const themeStyles = {
  default: {
    height: '32px',
    top: '-2px',
  },
  big: {
    height: '47px',
    top: '0',
  },
};

const themeCSS = ({ variant }) => {
  const props = themeStyles[variant] ? themeStyles[variant] : themeStyles.default;
  return css`
    ${Object.keys(props).map((prop) => `${prop}: ${props[prop]};`)}
  `;
};

export default styled(StopStatusLogStage)`
  position: relative;
  cursor: default;
  overflow-y: hidden;

  &.StopStatusLogStage-clickable {
    cursor: pointer;
  }

  ${themeCSS}
`;
